import { laEscucha } from "@/data/content";
import laEscuchaImage from "@/assets/la-escucha.jpg";
import PageHeader from "@/components/site/PageHeader";
import { Reveal } from "@/components/site/Reveal";
import BookCTA from "@/components/site/BookCTA";

export default function LaEscucha() {
  return (
    <div data-testid="la-escucha-page">
      <PageHeader
        overline="La Escucha"
        titleLines={["Una forma de", "comprender el", "sufrimiento humano"]}
      />

      <section className="max-w-[1400px] mx-auto px-5 md:px-10 mb-16 md:mb-28">
        <Reveal>
          <div className="overflow-hidden aspect-[16/9] md:aspect-[21/9]">
            <img
              src={laEscuchaImage}
              alt="Escultura contemplativa junto a libros de psicoanálisis"
              className="w-full h-full object-cover"
            />
          </div>
        </Reveal>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 md:px-10 pb-8">
        {laEscucha.sections.map((s, i) => (
          <div
            key={s.title}
            className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 py-14 md:py-20 border-t border-black/10"
          >
            <div className="md:col-span-4">
              <Reveal>
                <span className="overline block mb-3">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h2 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-tight">
                  {s.title}
                </h2>
              </Reveal>
            </div>
            <div className="md:col-span-7 md:col-start-6 space-y-5">
              {s.body.map((p, j) => (
                <Reveal key={j} delay={j * 0.08}>
                  <p className="text-lg md:text-xl leading-relaxed text-[#1a1a1a]/85 font-light">
                    {p}
                  </p>
                </Reveal>
              ))}
            </div>
          </div>
        ))}
      </section>

      <section className="max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-36">
        <Reveal>
          <p className="font-display italic text-3xl sm:text-4xl md:text-5xl leading-tight tracking-tight max-w-4xl">
            {laEscucha.closing}
          </p>
        </Reveal>
      </section>

      <BookCTA />
    </div>
  );
}
